import { cx } from "class-variance-authority";
import { HTMLAttributes } from "react";

const LoaderBar = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => {
    return <div
        className={cx("tw-w-full tw-h-2 tw-bg-accents-1 tw-rounded-full tw-overflow-hidden tw-flex tw-justify-center", className)}
        {...props}
    >
        <div className="tw-w-2/3 tw-h-full tw-bg-success tw-rounded-full tw-animate-mlr" />
    </div>;
};

export default LoaderBar;